var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#weight_svg__clip0_39_36)",
    stroke: "currentColor",
    strokeWidth: 1.007
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.833 5.167H4.167a1 1 0 0 0-1 1L.5 14.5a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1l-2.667-8.333a1 1 0 0 0-1-1Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2.439,
    r: 1.83
  }))));
};
export { SvgWeight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8zOV8zNikiPgo8cGF0aCBkPSJNMTEuODMzMyA1LjE2NjY5SDQuMTY2NjdDMy42MTQzOCA1LjE2NjY5IDMuMTY2NjcgNS42MTQ0IDMuMTY2NjcgNi4xNjY2OUwwLjUgMTQuNUMwLjUgMTUuMDUyMyAwLjk0NzcxNSAxNS41IDEuNSAxNS41SDE0LjVDMTUuMDUyMyAxNS41IDE1LjUgMTUuMDUyMyAxNS41IDE0LjVMMTIuODMzMyA2LjE2NjY5QzEyLjgzMzMgNS42MTQ0IDEyLjM4NTYgNS4xNjY2OSAxMS44MzMzIDUuMTY2NjlaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjAwNjU2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPGNpcmNsZSBjeD0iOC4wMDAwMiIgY3k9IjIuNDM4NTYiIHI9IjEuODMwMDUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMDA2NTYiLz4KPC9nPgo8ZGVmcz4KPC9kZWZzPgo8L3N2Zz4K";